import { render } from "./BottomContainer.vue?vue&type=template&id=d989916a"
const script = {}

import "./BottomContainer.vue?vue&type=style&index=0&id=d989916a&lang=scss"

import exportComponent from "/home/runner/work/maider_subscription/maider_subscription/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__